var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-2",attrs:{"id":"summary"}},[_c('div',{staticClass:"row"},[_c('v-col',[_c('v-card-text',{staticClass:"summary"},[_vm._v(" "+_vm._s(_vm.description)+" ")])],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }